import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStoreState } from 'src/entity/StateEntity';
import MallMedicineListPage from 'src/components/views/Mall/MedicineList';

const mapStateToProps = ({
  userState: { userInfo, isAgent },
  mallCategoryState: { categoryList },
  mallPharmacyState: { pharmacyList },
  spuTcmState: { tcmList },
  spuCpmState: { cpmList },
}: IStoreState) => ({
  isAgent,
  userInfo,
  categoryList,
  pharmacyList,
  tcmList,
  cpmList,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MallMedicineListPage);



// WEBPACK FOOTER //
// ./src/containers/MallMedicineList.ts